import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, IconButton, useTheme } from '@mui/material';
import './DefaultFree.scss';

interface DefaultFreeProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  isDisabled?: boolean,
  onClick?: () => void;
}

const DefaultFree = ({
  title,
  description,
  price,
  image,
  isDisabled,
  onClick,
}: DefaultFreeProps) => {
  const theme = useTheme();

  return (
    <ButtonBase
      onClick={onClick}
      className="dish dish--default-free"
      component="div"
      sx={{
        opacity: isDisabled ? 0.5: 1,
        ['& .dish__title']: {
          textDecoration: isDisabled ? 'line-through': 'none'
        }
      }}
    >
      <img className="dish__image" src={image} />
      <div className="dish__body">
        {title ? <h3 className="dish__title">{title}</h3> : null}
        {description ? (
          <p className="dish__description">{description}</p>
        ) : null}
        {price ? <p className="dish__price">{price}</p> : null}
        <div className="dish__actions">
          <IconButton
            className="dish__btn-details"
            onClick={onClick}
            sx={{ backgroundColor: theme?.palette?.primary?.main }}
          >
            <HugeiconsIcon icon={Add01Icon} className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};

export default DefaultFree;
